import { VideoExtensions, ManifestExtensions, } from '../Utils/Constants';
export default class Utils {
    static getRouteAndFilename(stringUrl) {
        const url = new URL(stringUrl);
        const route = url.origin + url.pathname;
        const limit = route.lastIndexOf('/') + 1;
        return {
            route: route.slice(0, limit),
            fileName: route.slice(limit)
        };
    }
    static getPath(stringUrl) {
        const url = new URL(stringUrl);
        const path = url.pathname;
        return {
            path: path
        };
    }
    static delay(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
    }
    static findPathMach(url, path, newCdn) {
        let updatedPath = newCdn.url;
        let originalUrl = url;
        url = url.split("?")[0];
        let current = new URL(url);
        let resource = new URL(path);
        if (current.host != resource.host) {
            current.host = resource.host;
            url = current.toString();
        }
        let value = path;
        if (path != undefined && path != '')
            while (!url.includes(path)) {
                if (!value.includes('/'))
                    break;
                if (value.endsWith('/')) {
                    value = value.substr(0, value.length - 1);
                }
                value = value.substr(0, value.lastIndexOf('/') + 1);
                if (value == 'https://' || value == 'http://') {
                    return '';
                }
            }
        let updatedUrl = url.replace(value, updatedPath);
        return updatedUrl;
    }
    static isMedia(path) {
        let isMedia = false;
        VideoExtensions.forEach((ext) => {
            isMedia = isMedia || path.endsWith(ext);
        });
        return isMedia;
    }
    static isManifest(path) {
        let isManifest = false;
        ManifestExtensions.forEach((ext) => {
            isManifest = isManifest || path.endsWith(ext);
        });
        return isManifest;
    }
    static bufferToString(b) {
        //eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        return String.fromCharCode.apply(null, new Uint8Array(b));
    }
    static returnRandom(a) {
        let ret = '';
        const len = a.length - 1;
        if (len > 0) {
            const position = Math.round(Math.random() * len);
            ret = a[position];
        }
        return ret;
    }
    static formatParameters(params) {
        return "?" + Object
            .keys(params)
            .map(function (key) {
            return key + "=" + encodeURIComponent(params[key]);
        })
            .join("&");
    }
}
